import { Button, Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import ProposalService from '../../services/ProposalService';
import ToolService from '../../services/ToolService';
import jsPDF, { HTMLOptions } from 'jspdf';
import autoTable, { RowInput } from 'jspdf-autotable';
import AttributeService from '../../services/AttributeService';
import fontInter from './../../assets/fonts/Urbanist-Regular.ttf';
import fontInterBold from './../../assets/fonts/Urbanist-Bold.ttf';
import { useNavigate } from 'react-router-dom';
import ImageService from '../../services/ImageService';
import {
    formatDerivedPeriod,
    formatDurationMonths,
    formatQuantityWithUnit,
    formatToTRY,
    openNotification
} from '../../utils';
import { addFooter, addHeader, fileToBase64, generateCover, getContent } from './generatePdf';
import { buildProposalPricing } from './proposalPricing';
import SettingService from '../../services/SettingService';
import image1 from "./img-1.png";
import image2 from "./img-2.png";
import coverBg from "./cover-bg.png";
import logoImage from "../../assets/kontrolx.png";


interface ProposalViewProps {
    proposalId: number;
    isCreate: any;
    isSendMail?: boolean;
    scheduledAt?: string | null;
    silent?: boolean;
    shouldNavigate?: boolean;
    onSuccess?: (archiveResponse?: any) => void;
    onError?: (error: unknown) => void;
}

interface CustomHTMLOptions extends HTMLOptions {
    pageBreak?: {
        mode?: string | string[];
        before?: string;
        after?: string;
        avoid?: string;
    };
}



const PdfUpload: React.FC<ProposalViewProps> = ({
    proposalId,
    isCreate,
    isSendMail = false,
    scheduledAt,
    silent = false,
    shouldNavigate = true,
    onSuccess,
    onError,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isInfoTableShow, setIsInfoTableShow] = useState(false);
    const [finalTable, setFinalTable] = useState<[string, string][]>([]);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [blob, setBlob] = useState<Blob | null>(null);
    const pdfInstanceRef = useRef<Blob | null>(null);
    const address = useRef<any>({});
    const [finalAttributes, setFinalAttributes] = useState<any[]>([]);
    const [logoBase64, setLogoBase64] = useState("");
    const [tools, setTools] = useState<any[]>([]);
    const [status, setStatus] = useState<any>(null);
    const count = useRef<any>(0);
    const navigate = useNavigate()

    useEffect(() => {
        const loadLogo = async () => {
            const logo = await fileToBase64(logoImage);
            setLogoBase64(logo);
        };

        loadLogo();
    }, []);

    useEffect(() => {
        // ToolService.getAllTools()
        //     .then((response) => {
        //         setTools(response.data);
        //     })
        //     .catch((error) => {
        //         console.error('Tool data fetch error:', error);
        //     });
    }, [logoBase64]);

    const showModal = async () => {
        const { groupedByOffering, data, formattedDate, serviceFeePrice } = await getInfos();
        await generatePdf(groupedByOffering, data, formattedDate, serviceFeePrice);
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const getServiceFeeFromSettings = async (): Promise<number | null> => {
        try {
            const settings = await SettingService.listSettings();
            const fee = settings.find((s) => s.key === 'SERVICE_FEE');
            const val = fee?.effectiveValue ?? fee?.value ?? fee?.defaultValue;
            const num = Number(val);
            return Number.isFinite(num) ? num : null;
        } catch (error) {
            console.error('Hizmet bedeli alınamadı', error);
            return null;
        }
    };

    const getProposalVersionFromSettings = async (): Promise<string> => {
        try {
            const settings = await SettingService.listSettings();
            const proposalVersionSetting = settings.find((s) => s.key === 'PROPOSAL_VERSION');
            return (
                proposalVersionSetting?.effectiveValue ??
                proposalVersionSetting?.value ??
                proposalVersionSetting?.defaultValue ??
                ''
            );
        } catch (error) {
            console.error('Teklif doküman versiyonu alınamadı', error);
            return '';
        }
    };


    const getInfos = async () => {
        try {
            // 1. AttributeService'den tüm attributeleri alıyoruz
            const attributesResponse: any = await AttributeService.getAll();
            const allAttributes: any[] = (attributesResponse?.data || []).sort(
                (a: any, b: any) => (a.order ?? 0) - (b.order ?? 0)
            );
            // 2. ProposalService'den belirli bir proposal'ı alıyoruz
            const response: any = await ProposalService.get(proposalId);
            const data: any = response?.data || {};

            // 3. AttributeService'den gelen attributeleri sıralama için bir haritaya çeviriyoruz
            // const attributeOrderMap: Map<any, any> = new Map(
            //     allAttributes.map((attr: any) => [attr.id, attr.order])
            // );
            const billingAddress = response.data.company?.addresses?.find(
                (address: any) => address.type === "BILLING"
            );
            address.current = data?.address;

            // 4. Bileşenli ve bileşensiz attributeleri ayırıyoruz
            // const nonCompositeAttributes: any[] =
            //     data.attributes?.filter((attr: any) => !attr.isComposite) || [];
            // const compositeAttributes: any[] =
            //     data.attributes?.filter((attr: any) => attr.isComposite) || [];

            // 5. Sıralama fonksiyonu
            // const sortByOrder = (a: any, b: any) => {
            //     const orderA = attributeOrderMap.get(a.attributeId) || Number.MAX_SAFE_INTEGER;
            //     const orderB = attributeOrderMap.get(b.attributeId) || Number.MAX_SAFE_INTEGER;
            //     return orderA - orderB;
            // };

            // 6. Bileşensiz ve bileşenli attributeleri sıralıyoruz
            // const sortedNonCompositeAttributes: any[] = [...nonCompositeAttributes].sort(sortByOrder);
            // const sortedCompositeAttributes: any[] = [...compositeAttributes].sort(sortByOrder);

            // 7. Sıralanmış attributeleri birleştiriyoruz
            // const finalSortedAttributes: any[] = [
            //     ...sortedNonCompositeAttributes,
            //     ...sortedCompositeAttributes,
            // ];
            data.allAttributes = allAttributes;

            // 8. Tarih formatlama işlemi
            const date: any = new Date(data?.createdAt ?? Date.now());
            const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('tr-TR', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                weekday: 'long',
            });
            const formattedDate: string = formatter.format(date);

            // 9. Price Calculation Response işlemleri
            const pricing = buildProposalPricing(data, allAttributes);
            const groupedByOffering: any = pricing.groupedByOffering;

            const [serviceFeePrice, proposalVersionSetting] = await Promise.all([
                getServiceFeeFromSettings(),
                getProposalVersionFromSettings(),
            ]);
            return { groupedByOffering, data, formattedDate, serviceFeePrice, proposalVersionSetting };
        } catch (error) {
            console.error('Error fetching proposal data:', error);
            throw error;
        }
    };

    // Footer'ı her sayfa için ekleme
    function addFootersToPDF(pdf: any, proposalData: any, proposalVersionSetting?: string | null) {
        const totalPages = pdf.internal.getNumberOfPages(); // Toplam sayfa sayısı

        for (let i = 2; i <= totalPages; i++) { // Kapak (sayfa 1) hariç
            pdf.setPage(i); // İlgili sayfayı seç
            let pageNum = i;
            addFooter(pdf, totalPages, pageNum, proposalData, proposalVersionSetting); // Footer ekle
        }
    }

    const convertFontToBase64 = async (fontUrl: string): Promise<string> => {
        const response = await fetch(fontUrl);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (reader.result) {
                    resolve((reader.result as string).split(',')[1]);
                } else {
                    reject('Font dosyası okunamadı.');
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(blob);
        });
    };

    const generatePdf = async (
        groupedByOffering: any,
        proposalData: any,
        createdAt: any,
        serviceFeePrice?: number | null,
        proposalVersionSetting?: string | null,
    ) => {
        // Bölüm 1 - Kırmızı ve tarih
        const pricing = buildProposalPricing(proposalData, proposalData?.allAttributes || []);

        let calculatedTable: string | any[] = [];

        const pdf = new jsPDF('portrait', 'mm', 'a4');
        const fontBase64 = await convertFontToBase64(fontInter);
        const fontBoldBase64 = await convertFontToBase64(fontInterBold);
        pdf.addFileToVFS('fontInter.ttf', fontBase64);
        pdf.addFileToVFS('fontInterBold.ttf', fontBoldBase64);
        pdf.addFont('fontInter.ttf', 'fontInter', 'normal');
        pdf.addFont('fontInterBold.ttf', 'fontInter', 'bold');
        pdf.setFont('fontInter');

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const resolvedLogoBase64 = logoBase64 || await fileToBase64(logoImage);

        //COVER START
        const backgroundImageBase64 = await fileToBase64(coverBg);
        generateCover(pdf, proposalData, pageHeight, pageWidth, createdAt, resolvedLogoBase64, backgroundImageBase64, proposalVersionSetting);
        //COVER END

        // Add new page for content
        pdf.addPage();
        addHeader(pdf, proposalData, resolvedLogoBase64);
        // Set currentY to keep track of vertical position
        let currentY = 40; // Header'ın altında başla
        const marginLeft: any = 12;
        const marginRight: any = 12;
        const maxLineWidth = pageWidth - marginLeft - marginRight;

        const htmlContent = getContent(proposalData, address, serviceFeePrice ?? undefined);

        // Create tempDiv and process content
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;

        const getTextContentFromNode = (node: any): any => {
            let textContent = '';
            if (node.nodeType === Node.TEXT_NODE) {
                textContent += node.textContent;
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                for (let child of node.childNodes) {
                    textContent += getTextContentFromNode(child);
                }
            }
            return textContent;
        };

        const calculateCustomTotal = (offeringList: any[]): number => {
            let total = 0;
            const visitedToolIds = new Set<number>(); // Aynı toolId'yi tekrar eklememek için

            // Tüm offeringler (itemler) üzerinden geç
            for (const item of offeringList) {
                // Her offering (item) içindeki attributes dizisini kontrol et
                if (item?.attributes && Array.isArray(item.attributes)) {
                    for (const attribute of item.attributes) {
                        if (!attribute.toolId) {
                            // toolId yoksa: finalPrice doğrudan eklenir
                            total += attribute.finalPrice;
                        } else {
                            // toolId varsa: groupTotalPrice'ı yalnızca bir kez ekliyoruz
                            if (!visitedToolIds.has(attribute.toolId)) {
                                total += attribute.groupTotalPrice;
                                visitedToolIds.add(attribute.toolId);
                            }
                        }
                    }
                }
            }

            return total;
        };

        // Process nodes and write to PDF using pdf.text
        const processNode = (node: any, indentLevel: any = 0) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                switch (node.tagName.toLowerCase()) {
                    case 'h1':
                        pdf.setFontSize(12);
                        pdf.setFont('fontInter', 'bold');
                        pdf.setTextColor(255, 255, 255);
                        pdf.setFillColor(51, 62, 72); // #333E48
                        let h1Text = getTextContentFromNode(node).trim();
                        if (currentY > pageHeight - 30) {
                            pdf.addPage();
                            addHeader(pdf, proposalData, resolvedLogoBase64);
                            currentY = 40;
                        }
                        // Yuvarlatılmış dikdörtgen çizimi
                        pdf.roundedRect(marginLeft, currentY, maxLineWidth, 11, 2, 2, 'F');
                        // Metni yatay ve dikey olarak ortala
                        const textWidth = pdf.getTextWidth(h1Text);
                        const textX = marginLeft + (maxLineWidth - textWidth) / 2;
                        const textHeight = pdf.getTextDimensions(h1Text).h;
                        const textY = currentY + (12 + textHeight) / 2 - 1; // Dikey ortalama için ayarlama
                        pdf.text(marginLeft + 4, textY, h1Text);
                        currentY += 14;
                        break;
                    case 'h2':
                        currentY += 2;
                        pdf.setFontSize(10);
                        pdf.setFont('fontInter', 'bold');
                        pdf.setTextColor(0, 0, 0);
                        if (currentY > pageHeight - 30) {
                            pdf.addPage();
                            addHeader(pdf, proposalData, resolvedLogoBase64);
                            currentY = 40;
                        }
                        currentY += 5;
                        pdf.text(marginLeft + 4 + indentLevel * 10, currentY, getTextContentFromNode(node).trim());
                        currentY += 5;
                        break;
                    case 'p':
                        currentY += 2;
                        pdf.setFontSize(8);
                        pdf.setFont('fontInter', 'normal');
                        pdf.setTextColor(0, 0, 0);
                        let paragraphText = getTextContentFromNode(node).trim();
                        const lines = pdf.splitTextToSize(paragraphText, (maxLineWidth - 4) - indentLevel * 10);
                        lines.forEach((line: any) => {
                            if (currentY > pageHeight - 30) {
                                pdf.addPage();
                                addHeader(pdf, proposalData, resolvedLogoBase64);
                                currentY = 40;
                            }
                            pdf.text(marginLeft + 4 + indentLevel * 10, currentY, line);
                            currentY += 4;
                        });
                        currentY += 2;
                        break;
                    case 'ol':
                        currentY += 2;
                        // Ordered list
                        processList(node, indentLevel);
                        break;
                    case 'ul':
                        currentY += 2;
                        // Unordered list
                        processList(node, indentLevel);
                        break;
                    default:
                        currentY += 2;
                        processNodeChildren(node, indentLevel);
                        break;
                }
            } else if (node.nodeType === Node.TEXT_NODE) {
                // Do nothing, text nodes are processed within elements
            }
        };

        const processNodeChildren = (node: any, indentLevel: number) => {
            for (let i = 0; i < node.childNodes.length; i++) {
                processNode(node.childNodes[i], indentLevel);
            }
        };

        const processList = (listNode: any, indentLevel: number) => {
            let listItems = listNode.childNodes;
            // Her bir <li> öğesinin metnini doğrudan ekliyoruz
            for (let i = 0; i < listItems.length; i++) {
                let item = listItems[i];
                if (item.nodeType === Node.ELEMENT_NODE && item.tagName.toLowerCase() === 'li') {
                    pdf.setFontSize(8);
                    pdf.setFont('fontInter', 'normal');
                    pdf.setTextColor(0, 0, 0);
                    // Bullet veya numara eklemiyoruz
                    let listItemText = getTextContentFromNode(item).trim();
                    const lines = pdf.splitTextToSize(
                        listItemText,
                        (maxLineWidth - 4) - (indentLevel + 1) * 5
                    );
                    lines.forEach((line: any) => {
                        if (currentY > pageHeight - 30) {
                            pdf.addPage();
                            addHeader(pdf, proposalData, resolvedLogoBase64);
                            pdf.setFontSize(8);
                            pdf.setFont('fontInter', 'normal');
                            pdf.setTextColor(0, 0, 0);
                            currentY = 40;
                        }
                        pdf.text(marginLeft + 2 + (indentLevel + 1) * 5, currentY, line);
                        currentY += 4;
                    });
                    // İsteğe bağlı: liste öğeleri arasında ekstra boşluk eklenebilir
                    currentY += 2;
                }
            }
        };

        processNodeChildren(tempDiv, 0);

        // Add new page for tables
        pdf.addPage();
        addHeader(pdf, proposalData, resolvedLogoBase64);
        currentY = 40; // Reset currentY for the new page
        const contentWidth = pageWidth - 32; // Her iki taraftan 16mm margin düşünülerek

        // IS EKIPMANI table
        if (groupedByOffering.equipment.length > 0) {
            // Sayfaya ilk yazılacak başlık (header dışında) örneği
            // Bu başlık ilk sayfada basılır. (Tabii header da basılır.)
            pdf.setFillColor(51, 62, 72); // #333E48
            pdf.roundedRect(marginLeft, currentY, maxLineWidth, 12, 2, 2, 'F');
            pdf.setFontSize(11);
            pdf.setFont('fontInter', 'bold');
            pdf.setTextColor(255, 255, 255);
            pdf.text('5. FİYATLANDIRMA', marginLeft + 5, currentY + 7);
            currentY += 16;

            pdf.setFontSize(8);
            pdf.setFont('fontInter', 'normal');
            pdf.setTextColor(0, 0, 0);
            currentY += 2;
            let paragraphText3 = '5.1. Periyodik kontrolü gerçekleştirilecek iş ekipmanları ve hizmet bedelleri aşağıdaki tabloda sunulmuştur.';
            const lines3 = pdf.splitTextToSize(paragraphText3, (maxLineWidth - 4));
            lines3.forEach((line: any) => {
                if (currentY > pageHeight - 30) {
                    pdf.addPage();
                    addHeader(pdf, proposalData, resolvedLogoBase64);
                    currentY = 40;
                }
                pdf.text(marginLeft + 5, currentY, line);
                currentY += 4;
            });

            pdf.setFontSize(8);
            pdf.setFont('fontInter', 'normal');
            pdf.setTextColor(0, 0, 0);
            currentY += 2;
            let paragraphText4 = '5.2. Aşağıda belirtilen hizmet bedellerine masraflar ve KDV dahil değildir. Masraflar, KONTROLX muayene personellerinin ulaşım, iaşe, konaklama giderlerinden oluşacaktır.';
            const lines4 = pdf.splitTextToSize(paragraphText4, (maxLineWidth - 4));
            lines4.forEach((line: any) => {
                if (currentY > pageHeight - 30) {
                    pdf.addPage();
                    addHeader(pdf, proposalData, resolvedLogoBase64);
                    currentY = 40;
                }
                pdf.text(marginLeft + 5, currentY, line);
                currentY += 4;
            });

            pdf.setFillColor('#D0CEDC');
            pdf.setTextColor(0, 0, 0);
            pdf.setFont('fontInter', 'bold');
            pdf.setFontSize(10);
            pdf.roundedRect(marginLeft, currentY, maxLineWidth, 12, 2, 2, 'F');
            pdf.text('PERİYODİK KONTROL MUAYENE HİZMETİ', marginLeft + 5, currentY + 7.25);
            currentY += 16;

            const equipmentHeaders = [
                ['İŞ EKİPMANI', 'AZAMİ SÜRE', 'KONTROL SAYISI', 'KONTROL PERİYODU', 'MİKTAR', 'BİRİM FİYAT', 'TOPLAM FİYAT'],
            ];

            // ------------------------------------------------------------------------------------
            // A) Ekipmanları (attributes) toparla
            // ------------------------------------------------------------------------------------
            let allAttributes: any[] = [];
            groupedByOffering.equipment.forEach((group: any) => {
                group.attributes.forEach((attr: any) => {
                    attr.isComposite = group.isComposite;
                    attr.toolId = attr.toolId || null;
                    attr.toolName = attr.toolName || null;
                    allAttributes.push(attr);
                });
            });

            const toolIdGrouped = allAttributes.reduce((acc: any, attr: any) => {
                if (attr.toolId) {
                    if (!acc[attr.toolId]) {
                        acc[attr.toolId] = { toolName: attr.toolName, attributes: [] };
                    }
                    acc[attr.toolId].attributes.push(attr);
                } else {
                    acc.noToolId = acc.noToolId || [];
                    acc.noToolId.push(attr);
                }
                return acc;
            }, {});

            // ------------------------------------------------------------------------------------
            // B) Bileşensiz attributeler (toolId olmayanlar) - noToolId
            // ------------------------------------------------------------------------------------
            if (toolIdGrouped.noToolId) {
                const ungroupedData: any = toolIdGrouped.noToolId.map((attr: any) => [
                    attr?.name,
                    formatDurationMonths(attr?.maxDurationMonths),
                    attr?.period,
                    formatDerivedPeriod(attr?.maxDurationMonths, attr?.period),
                    formatQuantityWithUnit(attr?.quantity, attr?.unit),
                    `${formatToTRY(Number(attr?.price ?? attr.discountDetails[0].price))} TL`,
                    `${formatToTRY(attr?.finalPrice)} TL`
                ]);

                autoTable(pdf, {
                    head: equipmentHeaders,
                    body: ungroupedData,
                    startY: currentY,
                    pageBreak: 'auto',
                    rowPageBreak: 'avoid',
                    theme: 'grid',
                    // Dikkat: header ile çakışmayı önlemek için top margin'i büyüttük (50).
                    margin: { left: 12, right: 12, top: 40, bottom: 35 },
                    styles: {
                        font: 'fontInter',
                        fontSize: 7,
                        valign: 'middle',
                        fillColor: '#F5F4F9',
                        textColor: [0, 0, 0],
                        minCellHeight: 4,
                        lineWidth: 0.5,
                        lineColor: [255, 255, 255],

                    },
                    headStyles: {
                        fillColor: [233, 232, 238],
                        fontSize: 8,
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                        valign: 'middle',
                        minCellHeight: 10,
                        halign: 'center',
                    },
                    columnStyles: {
                        0: { cellWidth: 46, valign: 'middle' },
                        1: { cellWidth: 19, valign: 'middle', halign: 'center' },
                        2: { cellWidth: 18, valign: 'middle', halign: 'center' },
                        3: { cellWidth: 18, valign: 'middle', halign: 'center' },
                        4: { cellWidth: 25, valign: 'middle', halign: 'center' },
                        5: { cellWidth: 30, valign: 'middle', halign: 'right' },
                        6: { cellWidth: 30, valign: 'middle', halign: 'right', fontStyle: 'bold' },
                    },
                    didDrawPage: (data) => {
                        // Her sayfa çizildiğinde header'ı ekle
                        addHeader(pdf, proposalData, resolvedLogoBase64);
                    }
                });

                currentY = (pdf as any).lastAutoTable.finalY;
            }

            // ------------------------------------------------------------------------------------
            // C) Bileşenli attributeler (toolId olanlar)
            // ------------------------------------------------------------------------------------
            let allAttributesSingle: any[] = [];
            groupedByOffering.equipment.forEach((group: any) => {
                group.attributes.forEach((attr: any) => {
                    allAttributesSingle.push(attr);
                });
            });
            groupedByOffering.measurement.forEach((group: any) => {
                group.attributes.forEach((attr: any) => {
                    allAttributesSingle.push(attr);
                });
            });

            if (groupedByOffering.equipment.length > 0) {
                let toolAttributes: any = [];
                let toolAttributesTable: any = [];

                Object.keys(toolIdGrouped).forEach((toolId) => {
                    if (toolId === 'noToolId') return;
                    const toolData = toolIdGrouped[toolId];

                    console.log('toolDatatoolDatatoolDatatoolData', toolData);

                    // Tüm attributelerin totalPrice hesaplaması
                    const updatedAttributes = toolData.attributes.map((attr: any) => {
                        const totalPriceFromDiscountDetails = attr.discountDetails.reduce(
                            (sum: number, discount: any) => sum + (discount.price * discount.quantity),
                            0
                        );
                        return {
                            ...attr,
                            totalPrice: totalPriceFromDiscountDetails
                        };
                    });

                    const totalPrice = toolData.attributes[0].groupTotalPrice || 0;
                    const toolName = toolData.toolName || '';
                    const totalPeriod = toolData.attributes[0].period || 1;
                    const maxDurationMonths = toolData.attributes[0].maxDurationMonths || 0;

                    // Alt alta ölçüm detayı
                    const measurementDetails = toolData.attributes
                        .map((attr: any) => `${attr.name} > ${formatQuantityWithUnit(attr.quantity, attr.unit)}`)
                        .join('\n');

                    // Tablodaki tek satır
                    const singleRow = [
                        toolName,
                        formatDurationMonths(maxDurationMonths),
                        totalPeriod,
                        formatDerivedPeriod(maxDurationMonths, totalPeriod),
                        measurementDetails,
                        `${formatToTRY(totalPrice)} TL`,
                    ];

                    console.log('singleRowsingleRowsingleRowsingleRow', singleRow);

                    toolAttributes[toolData?.attributes[0]?.order] = singleRow;

                    setFinalAttributes(prev => {
                        const map = new Map(prev.map(attr => [attr.attributeId, attr]));

                        toolData.attributes.forEach((attr: { attributeId: any; }) => {
                            console.log('setFinalAttributessetFinalAttributessetFinalAttributes', attr)
                            if (!map.has(attr.attributeId)) {
                                map.set(attr.attributeId, attr);
                            }
                        });

                        return Array.from(map.values());
                    });

                });

                toolAttributesTable = Object.keys(toolAttributes).map((order) => {
                    return toolAttributes[order];
                });

                calculatedTable = await allAttributes
                    .filter(attr => attr.toolId && attr.quantity !== 0)
                    .map(attr => {
                        console.log('calculatedTablecalculatedTablecalculatedTable12', attr);
                        const mainPrice = Number(attr.discountDetails?.[0]?.price) || 0;
                        const minPrice = Math.floor((attr?.finalPrice / (attr?.quantity*attr.period)) / 10) * 10;

                        console.log('ADETTENattrattrattrattr', attr);

                        return [
                            `${attr.quantity} ADETTEN SONRAKİ HER ${attr.name} İÇİN`,
                            `${formatToTRY(minPrice)} TL`,
                        ] as [string, string];
                    });

                if (toolAttributesTable.length > 0) {

                    const toolHeaders = [
                        [
                            'TESİSAT, SİSTEM',
                            'AZAMİ SÜRE',
                            'KONTROL SAYISI',
                            'KONTROL PERİYODU',
                            'ÖLÇÜM & KONTROL NOKTASI',
                            'TOPLAM FİYAT'
                        ],
                    ];

                    // // Sayfa yüksekliği ve margin değerleri (autoTable içinde kullanılan margin'lere göre)
                    // const toolPageHeight = pdf.internal.pageSize.getHeight();
                    // const toolBottomMargin = 35; // margin.bottom: 35
                    // const toolTopMargin = 40;    // margin.top: 40

                    // // Tabloyu eklemeyi planladığımız başlangıç Y değeri
                    // const toolTableStartY = currentY;

                    // // Mevcut sayfada kullanılabilecek alanı hesapla
                    // const toolAvailableSpace = toolPageHeight - toolTableStartY - toolBottomMargin;

                    // // Tahmini satır yüksekliği (minCellHeight: 10) ve tablo başlığı için de 1 satır kabul ediyoruz
                    // const toolEstimatedRowHeight = 10;
                    // const toolEstimatedHeaderHeight = toolEstimatedRowHeight;
                    // // Toplam tahmini tablo yüksekliği: başlık + veri satırları + küçük bir padding (örneğin +2)
                    // const toolEstimatedTableHeight = toolEstimatedHeaderHeight + (toolAttributes.length * toolEstimatedRowHeight) + 2;

                    // // Eğer tahmini tablo yüksekliği mevcut alandan büyükse yeni sayfa ekle ve header'ı çiz
                    // if (toolEstimatedTableHeight > toolAvailableSpace) {
                    //     pdf.addPage();
                    //     addHeader(pdf, proposalData, resolvedLogoBase64);
                    //     // Yeni sayfada header altında başlaması için currentY'yi ayarla (örneğin 50)
                    //     currentY = 50;
                    // }

                    // Tabloyu çiz
                    autoTable(pdf, {
                        head: toolHeaders,
                        body: toolAttributesTable,
                        startY: currentY,
                        theme: 'grid',
                        pageBreak: 'auto',
                        rowPageBreak: 'avoid',
                        margin: { left: 12, right: 12, top: 40, bottom: 35 },
                        styles: {
                            font: 'fontInter',
                            fontSize: 7,
                            valign: 'middle',
                            fillColor: '#F5F4F9',
                            textColor: [0, 0, 0],
                            lineColor: [255, 255, 255],
                            lineWidth: 0.5,
                        },
                        headStyles: {
                            fillColor: [233, 232, 238],
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                            fontSize: 8,
                            valign: 'middle',
                            halign: 'center',
                        },
                        columnStyles: {
                            0: { cellWidth: 46, valign: 'middle' },
                            1: { cellWidth: 19, valign: 'middle', halign: 'center' },
                            2: { cellWidth: 18, valign: 'middle', halign: 'center' },
                            3: { cellWidth: 18, valign: 'middle', halign: 'center' },
                            4: { cellWidth: 55, valign: 'middle' },
                            5: { cellWidth: 30, valign: 'middle', halign: 'right', fontStyle: 'bold' },
                        },
                        didDrawPage: (data) => {
                            // Her sayfa çiziminde header ekle
                            addHeader(pdf, proposalData, resolvedLogoBase64);
                        }
                    });

                    // currentY'yi, tabloda çizimin bittiği yer olarak güncelle
                    currentY = (pdf as any).lastAutoTable.finalY;
                }
            }

            // ------------------------------------------------------------------------------------
            // D) GENEL TOPLAM Tablosu
            // ------------------------------------------------------------------------------------
            const equipmentTotal = groupedByOffering.equipment.reduce(
                (sum: number, group: any) => sum + Number(group.totalPrice) || 0,
                0
            );
            console.log('groupedByOffering.equipment', groupedByOffering.equipment);

            const boxWidth = 80;
            const boxHeight = 10;
            const boxX = pageWidth - boxWidth - 12;
            const boxY = currentY + 5;

            const equipmentOriginalTotal = groupedByOffering.equipment.reduce(
                (sum: number, group: any) => sum + Number(group.finalPrice) || 0,
                0
            );
            const equipmentDiscountTotal = groupedByOffering.equipment.reduce(
                (sum: number, group: any) => sum + Number(group.discountAmount) || 0,
                0
            );

            const equipmentServiceFeeDifferenceTotal = groupedByOffering.equipment.reduce((sum: any, item: any) => {
                return sum + (Number(item.serviceFeeDifference) || 0);
            }, 0);
            const electricServiceFeeDifferenceTotal = groupedByOffering.equipment.reduce((sum: any, item: any) => {
                return sum + (Number(item.electricServiceFeeDifference) || 0);
            }, 0);
            const machineryServiceFeeDifferenceTotal = groupedByOffering.equipment.reduce((sum: any, item: any) => {
                return sum + (Number(item.machineryServiceFeeDifference) || 0);
            }, 0);

            // Kullanıcı fonksiyonu olduğunu varsaydığımız hesaplama (örnek)
            const equipmentFinalTotal = calculateCustomTotal(groupedByOffering.equipment)
                + (equipmentServiceFeeDifferenceTotal ?? 0);

            const tableDataPrices = [];

            if (groupedByOffering.equipmentDiscountPart > 0 || equipmentServiceFeeDifferenceTotal > 0) {
                tableDataPrices.push([
                    'Periyodik Kontrol Hizmeti Toplam',
                    `${formatToTRY(equipmentOriginalTotal - equipmentServiceFeeDifferenceTotal)} TL`
                ]);

                if (electricServiceFeeDifferenceTotal > 0) {
                    tableDataPrices.push([
                        'Elektrik Servis Ücreti',
                        `${formatToTRY(electricServiceFeeDifferenceTotal)} TL`
                    ]);
                }
                if (machineryServiceFeeDifferenceTotal > 0) {
                    tableDataPrices.push([
                        'Makine Servis Ücreti',
                        `${formatToTRY(machineryServiceFeeDifferenceTotal)} TL`
                    ]);
                }
                if (groupedByOffering.equipmentDiscountPart > 0) {
                    tableDataPrices.push([
                        "İndirim (-)",
                        `${formatToTRY(groupedByOffering.equipmentDiscountPart)} TL`
                    ]);
                }
            }

            tableDataPrices.push([
                'Periyodik Kontrol Hizmeti Genel Toplam',
                `${formatToTRY(Number(groupedByOffering.equipmentNet ?? (equipmentFinalTotal - groupedByOffering.equipmentDiscountPart)))} TL`
            ]);

            const equipmentTableLeft = 12;
            const equipmentSummaryLeft = equipmentTableLeft + 46 + 19;
            const equipmentTotalPriceLeft = equipmentTableLeft + 46 + 19 + 18 + 18 + 25 + 30;
            const equipmentSummaryLabelWidth = equipmentTotalPriceLeft - equipmentSummaryLeft;
            const equipmentSummaryAmountWidth = 30;

            // Genel toplam tablosu
            autoTable(pdf, {
                body: tableDataPrices,
                startY: currentY + 0.2,
                theme: 'plain',
                pageBreak: 'auto',
                rowPageBreak: 'avoid',
                margin: {
                    left: equipmentSummaryLeft,
                    top: 40,
                    bottom: 40,
                },
                willDrawCell: function (data) {
                    if (
                        data.section === 'body' &&
                        typeof data.cell.raw === 'string' &&
                        data.cell.raw.startsWith('İndirim (-)')
                    ) {
                        const label = 'İndirim ';
                        const discount = '(-)';
                        const doc = data.doc;

                        // ---- ÖNCE ARKA PLANI BOYA ----
                        // Tablo fillColor ile aynı renk (ör: #e8e8ed)
                        doc.setFillColor(232, 232, 237); // RGB karşılığı: #e8e8ed
                        doc.rect(
                            data.cell.x + 0.2,
                            data.cell.y + 0.2,
                            data.cell.width,
                            data.cell.height,
                            'F' // F = fill
                        );

                        // Tablo ayarlarıyla uyumlu font ve boyut
                        doc.setFont('fontInter', 'bold');
                        doc.setFontSize(8); // tablo fontSize ile aynı olmalı

                        // Yatay ortalama için x + padding
                        const x = data.cell.x + 2;
                        // Dikey ortalama için
                        const y =
                            (data.cell.y + data.cell.height / 2 + doc.getFontSize() / 2.8) - 3; // Gerekirse ince ayar

                        // Önce siyah "İndirim " yaz
                        doc.setTextColor(0, 0, 0);
                        doc.text(label, x, y, { baseline: 'middle' });

                        // Kırmızı "(-)" hemen yanına
                        doc.setTextColor(255, 0, 0);
                        const labelWidth = doc.getTextWidth(label);
                        doc.text(discount, x + labelWidth, y, { baseline: 'middle' });

                        // Eski cell text'i yazdırmasın
                        return false;
                    }
                },
                styles: {
                    valign: 'middle',
                    halign: 'right',
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    lineColor: [255, 255, 255],
                    lineWidth: 0.5,
                    minCellHeight: 10,
                    fontStyle: 'bold',
                    font: 'fontInter',
                    fillColor: '#e8e8ed',
                },
                columnStyles: {
                    0: { cellWidth: equipmentSummaryLabelWidth, halign: 'left' },
                    1: { cellWidth: equipmentSummaryAmountWidth, halign: 'right', fontStyle: 'bold' },
                },
                didDrawPage: (data) => {
                    addHeader(pdf, proposalData, resolvedLogoBase64);
                }
            });

            currentY = (pdf as any).lastAutoTable.finalY;

            // Son tablo

            autoTable(pdf, {
                body: finalTable,
                startY: currentY + 0.2,
                theme: 'plain',
                pageBreak: 'auto',
                rowPageBreak: 'avoid',
                margin: { left: 12, right: 12, top: 40, bottom: 35 },
                styles: {
                    font: 'fontInter',
                    fontSize: 7,
                    valign: 'middle',
                    fillColor: '#F5F4F9',
                    textColor: [0, 0, 0],
                    lineColor: [255, 255, 255],
                    lineWidth: 0.5,
                    minCellHeight: 10,
                },
                columnStyles: {
                    0: { cellWidth: 156 },
                    1: { cellWidth: 30, halign: 'right', fontStyle: 'bold' },
                },
                didDrawPage: (data) => {
                    addHeader(pdf, proposalData, resolvedLogoBase64);
                }
            });

            currentY = (pdf as any).lastAutoTable.finalY + 5;

        } // if 

        const rowHeight = 10; // varsayım: her satır 10pt yer kaplıyor
        const availableHeight = pageHeight - currentY - 30; // 20pt alt boşluk varsayalım
        const maxRows = Math.floor(availableHeight / rowHeight);

        // calculatedTable'ı ikiye böl
        const tablePart1 = calculatedTable.slice(0, maxRows);
        const tablePart2 = calculatedTable.slice(maxRows);

        // İlk sayfaya sığacak kısmı çiz
        autoTable(pdf, {
            body: tablePart1,
            startY: currentY,
            styles: {
                font: 'fontInter',
                fontSize: 7,
                valign: 'middle',
                fillColor: '#F5F4F9',
                textColor: [0, 0, 0],
                lineColor: [255, 255, 255],
                lineWidth: 0.5,
                minCellHeight: rowHeight,
            },
            columnStyles: {
                0: { cellWidth: 156 },
                1: { cellWidth: 30, halign: 'right', fontStyle: 'bold' },
            },
            margin: { left: 12, right: 12 },
            theme: 'plain',
        });

        currentY = (pdf as any).lastAutoTable.finalY + 5;

        // Eğer taşan satırlar varsa, yeni sayfaya geçip orada startY = 70 ile çiz
        if (tablePart2.length > 0) {
            pdf.addPage();
            addHeader(pdf, proposalData, resolvedLogoBase64);
            autoTable(pdf, {
                body: tablePart2,
                startY: 40,
                styles: {
                    font: 'fontInter',
                    fontSize: 7,
                    valign: 'middle',
                    fillColor: '#F5F4F9',
                    textColor: [0, 0, 0],
                    lineColor: [255, 255, 255],
                    lineWidth: 0.5,
                    minCellHeight: rowHeight,
                },
                columnStyles: {
                    0: { cellWidth: 156 },
                    1: { cellWidth: 30, halign: 'right', fontStyle: 'bold' },
                },
                margin: { left: 12, right: 12 },
                theme: 'plain',
            });

            currentY = (pdf as any).lastAutoTable.finalY + 5;
        }


        // IS HIJYENI table
        if (groupedByOffering.measurement.length > 0) {
            const toolPageHeight = pdf.internal.pageSize.getHeight();
            const toolBottomMargin = 35; // margin.bottom: 35

            const toolTableStartY = currentY;

            const toolAvailableSpace = toolPageHeight - toolTableStartY - toolBottomMargin;

            // Eğer tahmini tablo yüksekliği mevcut alandan büyükse yeni sayfa ekle ve header'ı çiz
            if (40 > toolAvailableSpace) {
                pdf.addPage();
                addHeader(pdf, proposalData, resolvedLogoBase64);
                // Yeni sayfada header altında başlaması için currentY'yi ayarla (örneğin 50)
                currentY = 35;
            }
            // --------------------------------------------------------
            // 0) Bu tabloya özel başlık
            // --------------------------------------------------------
            currentY += 5;
            pdf.setFont('fontInter', 'bold');
            pdf.setFillColor('#D0CEDC');
            pdf.setTextColor(0, 0, 0);
            pdf.roundedRect(marginLeft, currentY, maxLineWidth, 12, 2, 2, 'F');
            pdf.setFontSize(10);
            pdf.text('İŞ HİJYENİ ÖLÇÜM HİZMETİ', marginLeft + 5, currentY + 7.25);
            currentY += 16;

            // Tüm ölçüm attributes
            let allMeasurements: any[] = [];

            // --------------------------------------------------------
            // 1) Ölçüm verilerini toparlayalım
            // --------------------------------------------------------
            if (groupedByOffering.measurement.length > 0) {
                const measurementHeaders = [
                    ['ÖLÇÜM TÜRÜ', 'AZAMİ SÜRE', 'KONTROL SAYISI', 'KONTROL PERİYODU', 'MİKTAR', 'BİRİM FİYAT', 'TOPLAM FİYAT'],
                ];

                // Ölçümleri toplama
                groupedByOffering.measurement.forEach((group: any) => {
                    group.attributes.forEach((attr: any) => {
                        attr.isComposite = group.isComposite;
                        attr.period = group.period; // group.period varsa ona atıyoruz
                        allMeasurements.push(attr);
                    });
                });

                // isComposite = false (bileşensiz) ölçümleri tabloya dökelim
                const measurementData = allMeasurements
                    .filter((attr: any) => !attr.isComposite)
                    .map((attr: any) => {
                        // TOPLAM FİYAT HESAPLAMA

                        return [
                            attr.name,
                            formatDurationMonths(attr.maxDurationMonths),
                            attr.period || 1,
                            formatDerivedPeriod(attr.maxDurationMonths, attr.period || 1),
                            formatQuantityWithUnit(attr.quantity, attr.unit),
                            `${formatToTRY(Number(attr?.price ?? attr.discountDetails?.[0]?.price))} TL`,
                            `${formatToTRY(attr?.finalPrice)} TL`
                        ];
                    });

                // Eğer bileşensiz (isComposite=false) veri varsa tabloyu bas
                if (measurementData.length > 0) {
                    autoTable(pdf, {
                        head: measurementHeaders,
                        body: measurementData,
                        startY: currentY,
                        pageBreak: 'auto',
                        rowPageBreak: 'avoid',
                        theme: 'grid',
                        // Dikkat: header ile çakışmayı önlemek için top margin'i büyüttük (50).
                        margin: { left: 12, right: 12, top: 40, bottom: 35 },
                        styles: {
                            font: 'fontInter',
                            fontSize: 7,
                            valign: 'middle',
                            fillColor: '#F5F4F9',
                            textColor: [0, 0, 0],
                            minCellHeight: 4,
                            lineWidth: 0.5,
                            lineColor: [255, 255, 255],

                        },
                        headStyles: {
                            fillColor: [233, 232, 238],
                            fontSize: 8,
                            textColor: [0, 0, 0],
                            fontStyle: 'bold',
                            valign: 'middle',
                            minCellHeight: 10,
                            halign: 'center',
                        },
                        columnStyles: {
                            0: { cellWidth: 46, valign: 'middle' },
                            1: { cellWidth: 19, valign: 'middle', halign: 'center' },
                            2: { cellWidth: 18, valign: 'middle', halign: 'center' },
                            3: { cellWidth: 18, valign: 'middle', halign: 'center' },
                            4: { cellWidth: 25, valign: 'middle', halign: 'center' },
                            5: { cellWidth: 30, valign: 'middle', halign: 'right' },
                            6: { cellWidth: 30, valign: 'middle', halign: 'right', fontStyle: 'bold' },
                        },
                        didDrawPage: (data) => {
                            // Her sayfa çizildiğinde header'ı ekle
                            addHeader(pdf, proposalData, resolvedLogoBase64);
                        }
                    });

                    // Tablonun altına geldik, oradan devam edelim
                    currentY = (pdf as any).lastAutoTable.finalY;
                }
            }

            // --------------------------------------------------------
            // 2) Kompozit (isComposite=true) ölçümler
            // --------------------------------------------------------
            const compositeMeasurements = groupedByOffering.measurement.filter((group: any) => group.isComposite);
            if (compositeMeasurements.length > 0) {
                const toolHeaders = [
                    ['ÖLÇÜM TÜRÜ', 'AZAMİ SÜRE', 'KONTROL SAYISI', 'KONTROL PERİYODU', 'ÖLÇÜM & KONTROL NOKTASI', 'TOPLAM FİYAT'],
                ];

                const toolAttributes = compositeMeasurements.map((group: any) => {
                    const firstAttr = group.attributes?.[0] || {};
                    const totalPrice = Number(group.finalPrice) || group.attributes.reduce((sum: number, attr: any) => sum + (Number(attr.finalPrice) || 0), 0);
                    const detail = (group.attributes || [])
                        .map((attr: any) => `${attr.name} > ${formatQuantityWithUnit(attr.quantity, attr.unit)}`)
                        .join('\n');
                    return [
                        group.offeringName || firstAttr.name,
                        formatDurationMonths(firstAttr.maxDurationMonths),
                        firstAttr.period,
                        formatDerivedPeriod(firstAttr.maxDurationMonths, firstAttr.period),
                        detail || '-',
                        `${formatToTRY(totalPrice)} TL`,
                    ];
                });

                autoTable(pdf, {
                    head: toolHeaders,
                    body: toolAttributes,
                    startY: currentY,
                    pageBreak: 'auto',
                    rowPageBreak: 'avoid',
                    margin: {
                        left: 12,
                        right: 12,
                        top: 50,
                        bottom: 40,
                    },
                    styles: {
                        font: 'fontInter',
                        fontSize: 7,
                        valign: 'middle'
                    },
                    headStyles: {
                        fillColor: '#F5F4F9',
                        textColor: [0, 0, 0],
                        fontStyle: 'bold',
                        valign: 'middle',
                        font: 'fontInter',
                    },
                    columnStyles: {
                        0: { cellWidth: 46 },
                        1: { cellWidth: 19, halign: 'center' },
                        2: { cellWidth: 18, halign: 'center' },
                        3: { cellWidth: 18, halign: 'center' },
                        4: { cellWidth: 55 },
                        5: { cellWidth: 30, fontStyle: 'bold', halign: 'right' },
                    },
                    didDrawPage: (data) => {
                        addHeader(pdf, proposalData, resolvedLogoBase64);
                    }
                });

                currentY = (pdf as any).lastAutoTable.finalY;
            }

            // --------------------------------------------------------
            // 3) Hizmet Ücreti ve Genel Toplam bilgileri
            // --------------------------------------------------------
            const equipmentServiceFeeDifferenceTotal = groupedByOffering.measurement.reduce(
                (sum: any, item: any) => sum + (Number(item.serviceFeeDifference) || 0),
                0
            );

            const equipmentOriginalTotal = groupedByOffering.measurement.reduce(
                (sum: number, group: any) => sum + Number(group.finalPrice) || 0,
                0
            );

            const equipmentDiscountTotal = groupedByOffering.measurement.reduce(
                (sum: number, group: any) => sum + Number(group.discountAmount) || 0,
                0
            );

            const equipmentFinalTotal = groupedByOffering.measurement.reduce(
                (sum: number, group: any) => sum + Number(group.finalPrice) || 0,
                0
            );

            // Toplamları tabloda göstermek için dizi
            const tableDataPrices: any = [];

            if (groupedByOffering.measurementDiscountPart > 0 || equipmentServiceFeeDifferenceTotal > 0) {
                // Örnek: (equipmentOriginalTotal - equipmentServiceFeeDifferenceTotal).toFixed(2) 
                // DİKKAT: Yazarken parantezleri doğru kullanalım:
                const measurementBaseTotal = (equipmentOriginalTotal - equipmentServiceFeeDifferenceTotal).toFixed(2);

                tableDataPrices.push([
                    'İş Hijyeni Ölçüm Hizmeti Toplam',
                    `${formatToTRY(Number(measurementBaseTotal))} TL`
                ]);

                if (groupedByOffering.measurementDiscountPart > 0) {
                    tableDataPrices.push([
                        "İndirim (-)",
                        `${formatToTRY(groupedByOffering.measurementDiscountPart)} TL`
                    ]);
                }

                if (equipmentServiceFeeDifferenceTotal > 0) {
                    tableDataPrices.push([
                        'Servis Ücreti',
                        `${formatToTRY(equipmentServiceFeeDifferenceTotal)} TL`
                    ]);
                }
            }

            // Genel Toplam
            const finalMeasurementTotal = Number(
                groupedByOffering.measurementNet ?? (equipmentFinalTotal - groupedByOffering.measurementDiscountPart)
            ).toFixed(2);
            tableDataPrices.push([
                'İş Hijyeni Ölçüm Hizmeti Genel Toplam',
                `${formatToTRY(Number(finalMeasurementTotal))} TL`
            ]);

            // Artık tabloyu basalım
            autoTable(pdf, {
                body: tableDataPrices,
                startY: currentY + 0.2,
                theme: 'plain',
                pageBreak: 'auto',
                rowPageBreak: 'avoid',
                margin: {
                    left: pdf.internal.pageSize.getWidth() - 126,
                    top: 50,
                    bottom: 40,
                },
                willDrawCell: function (data) {
                    if (
                        data.section === 'body' &&
                        typeof data.cell.raw === 'string' &&
                        data.cell.raw.startsWith('İndirim (-)')
                    ) {
                        const label = 'İndirim ';
                        const discount = '(-)';
                        const doc = data.doc;

                        // ---- ÖNCE ARKA PLANI BOYA ----
                        // Tablo fillColor ile aynı renk (ör: #e8e8ed)
                        doc.setFillColor(232, 232, 237); // RGB karşılığı: #e8e8ed
                        doc.rect(
                            data.cell.x + 0.2,
                            data.cell.y + 0.2,
                            data.cell.width,
                            data.cell.height,
                            'F' // F = fill
                        );

                        // Tablo ayarlarıyla uyumlu font ve boyut
                        doc.setFont('fontInter', 'bold');
                        doc.setFontSize(8); // tablo fontSize ile aynı olmalı

                        // Yatay ortalama için x + padding
                        const x = data.cell.x + 2;
                        // Dikey ortalama için
                        const y =
                            (data.cell.y + data.cell.height / 2 + doc.getFontSize() / 2.8) - 3; // Gerekirse ince ayar

                        // Önce siyah "İndirim " yaz
                        doc.setTextColor(0, 0, 0);
                        doc.text(label, x, y, { baseline: 'middle' });

                        // Kırmızı "(-)" hemen yanına
                        doc.setTextColor(255, 0, 0);
                        const labelWidth = doc.getTextWidth(label);
                        doc.text(discount, x + labelWidth, y, { baseline: 'middle' });

                        // Eski cell text'i yazdırmasın
                        return false;
                    }
                },
                styles: {
                    valign: 'middle',
                    halign: 'right',
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    lineColor: [255, 255, 255],
                    lineWidth: 0.5,
                    minCellHeight: 10,
                    fontStyle: 'bold',
                    font: 'fontInter',
                    fillColor: '#e8e8ed',
                },
                columnStyles: {
                    0: { cellWidth: 84, halign: 'left', fontStyle: 'bold' },
                    1: { cellWidth: 30, halign: 'right', fontStyle: 'bold' },
                },
                didDrawPage: (data) => {
                    addHeader(pdf, proposalData, resolvedLogoBase64);
                }
            });

            currentY = (pdf as any).lastAutoTable.finalY;
        }

        // Yeni sayfa ve içerik ekleme
        pdf.addPage();
        addHeader(pdf, proposalData, resolvedLogoBase64);
        currentY = 40;

        // CALISMA PLANI başlığı ve metni
        const htmlContent2 = `
<body>
    <h1>6. ÇALIŞMA PLANI</h1>
    <p>Fiyatlandırma maddesinde belirtilen ekipman sayılarına, tesisatlarda bulunan ölçüm noktalarına göre kontrollerin gerçekleştirilmesi ve raporlanması ile ilgili çalışmalarda görev alması planlanan uzman/uzmanlar, kontrol ve raporlama süreleri belirlenmiştir. Ekipman sayılarındaki değişiklikler (artış veya azalış) ile kontrol esnasında uzmanların bir ekipmandan diğer ekipmanın kontrolüne geçerken harcadığı süreler planlanan kontrol süresini etkilemektedir.</p>
</body>
         `;

        const tempDiv2 = document.createElement('div');
        tempDiv2.innerHTML = htmlContent2;
        processNodeChildren(tempDiv2, 0);

        const leftMargin = 12;
        const rightMargin = 12;
        const gutter = 10;
        const contentWidth2 = pageWidth - leftMargin - rightMargin;
        const boxWidth = (contentWidth2 - gutter) / 2;
        const boxHeight = 50; // Resimlerin boyutu 70x70
        const boxY = currentY;

        const box1X = leftMargin;
        const box2X = box1X + boxWidth + gutter;

        // Arka plan rengi #F5F4F9
        pdf.setFillColor(245, 244, 249);

        // Kutuların çizimi
        pdf.roundedRect(box1X, boxY, boxWidth, boxHeight, 2, 2, 'F');
        pdf.roundedRect(box2X, boxY, boxWidth, boxHeight, 2, 2, 'F');

        // İlk kutu içeriği
        const halfBoxWidth = boxWidth / 2;

        // Resim ekleme (logoData dahil edilmiyor)
        const imageWidth = 30;
        const imageHeight = 40;
        const imageX1 = box1X + (halfBoxWidth - imageWidth) / 2;
        const imageY = boxY + 10;

        pdf.addImage(image2, 'PNG', imageX1, imageY, 30, 30);

        // Text ekleme
        const textX1 = box1X + halfBoxWidth;
        const textWidth1 = boxWidth - halfBoxWidth;
        const text1 = 'KONTROLLERİN GERÇEKLEŞTİRİLMESİ İÇİN PLANLANAN SÜRE (Gün)';
        const textLines1 = pdf.splitTextToSize(text1, textWidth1);
        pdf.setFontSize(8);
        pdf.setFont('fontInter', 'normal');
        pdf.setTextColor(0, 0, 0);
        pdf.text(textLines1, textX1, boxY + 15, { maxWidth: textWidth1 });

        const attributes = proposalData?.attributes;

        // Toplam dakikayı hesapla
        let totalReportMinutes = 0;
        const groupedControlMinutes: any = {};

        attributes?.forEach((attribute: any) => {
            const quantity = attribute?.quantity || 0;
            const period = attribute?.period || 0;
            const timeControl = attribute?.fieldControlTime || 0;
            const timeReport = attribute?.reportPreparationTime || 0;

            totalReportMinutes += (period * quantity) * timeReport;

            console.log("attribute", attribute);

            const offeringName = attribute?.offeringName;
            console.log("offeringName", offeringName);
            if (!groupedControlMinutes[offeringName]) {
                groupedControlMinutes[offeringName] = 0;
            }
            groupedControlMinutes[offeringName] += (period * quantity) * timeControl;
            console.log("groupedControlMinutes11", groupedControlMinutes);

        });

        console.log("groupedControlMinutes22", groupedControlMinutes);

        let totalControlDays = 0;
        for (const offering in groupedControlMinutes) {
            totalControlDays += Math.ceil(groupedControlMinutes[offering] / 480);
        }

        // Eğer totalControlDays değerini string olarak kullanmanız gerekiyorsa:
        const fourText = String(totalControlDays);

        // Altına ortalanmış '4' yazısı
        pdf.setFontSize(12); // Textten 4 px daha büyük

        const fourTextWidth = pdf.getTextWidth(fourText);
        const fourX = textX1 + (textWidth1 - fourTextWidth) / 2;
        pdf.text(fourText, fourX - 10, boxY + 35);
        // İkinci kutu içeriği
        // Resim ekleme (logoData dahil edilmiyor)
        const imageX2 = box2X + (halfBoxWidth - imageWidth) / 2;

        pdf.addImage(image1, 'PNG', imageX2 - 2, imageY, 38, 29);

        // Text ekleme
        const textX2 = box2X + halfBoxWidth;
        const textWidth2 = boxWidth - halfBoxWidth + 15;
        const text2 = 'KONTROL SONUÇLARININ RAPORLANMASI İÇİN PLANLANAN SÜRE (Gün)';
        const textLines2 = pdf.splitTextToSize(text2, textWidth2);
        pdf.setFontSize(8);
        pdf.text(textLines2, textX2, boxY + 15, { maxWidth: textWidth2 });

        // Altına ortalanmış '4' yazısı
        const totalReportDays = (totalReportMinutes / 480).toFixed(1);

        pdf.setFontSize(12); // Textten 4 px daha büyük
        const fourText2 = totalReportDays;
        const fourTextWidth2 = pdf.getTextWidth(fourText2);
        const fourX2 = textX2 + (textWidth2 - fourTextWidth2) / 2;
        pdf.text(fourText2, fourX2 - 10, boxY + 35);

        currentY = boxY + boxHeight + 8;

        // 'ODEME PLANI' başlığı ve metni
        pdf.setFontSize(11);
        pdf.setFont('fontInter', 'bold');
        pdf.setTextColor(255, 255, 255);
        pdf.setFillColor("#333E48");
        const h1Text: string = '7. ÖDEME PLANI';
        const h1Lines: string[] = pdf.splitTextToSize(h1Text, maxLineWidth);

        if (currentY > pageHeight - 30) {
            pdf.addPage();
            addHeader(pdf, proposalData, resolvedLogoBase64);
            currentY = 40;
        }

        pdf.roundedRect(
            marginLeft,
            currentY,
            maxLineWidth,
            12,
            2,
            2,
            'F'
        );

        // Metni ekleyin
        pdf.text(h1Lines, marginLeft + 5, currentY + 7);
        currentY += 16;

        // Metin
        pdf.setFontSize(8);
        pdf.setFont('fontInter', 'normal');
        pdf.setTextColor(0, 0, 0);
        currentY += 2;
        let paragraphText = "Hizmet bedelinin %50'si teklifin onayına istinaden, kalan bakiye ise periyodik kontrol hizmetinin tamamlanmasına müteakip aşağıda belirtilmiş olan hesap numaralarına yapılır.";
        const lines2 = pdf.splitTextToSize(paragraphText, (maxLineWidth - 4));
        lines2.forEach((line: any) => {
            if (currentY > pageHeight - 30) {
                pdf.addPage();
                addHeader(pdf, proposalData, resolvedLogoBase64);
                currentY = 40;
            }
            pdf.text(marginLeft, currentY, line);
            currentY += 4;
        });

        // Banka Hesap Bilgileri tablosu
        const bankTableHeaders = [['Banka Hesap Bilgileri', 'IBAN Bilgisi']];
        const bankTableData = [
            ['TÜRKİYE VAKIFLAR BANKASI - İkitelli Organize Sanayi Şubesi (S01072)', 'TR59 0001 5001 5800 7331 8277 85'],
            ['TÜRKİYE HALK BANKASI - İkitelli Şubesi (0815)', 'TR35 0001 2009 8150 0010 2621 73'],
            ['KUVEYT TÜRK KATILIM BANKASI - İkitelli Şubesi (0029)', 'TR09 0020 5000 0982 7213 1000 01'],
        ];

        // Türkçe karakterleri İngilizceye çevir
        bankTableData.forEach((row, index) => {
            bankTableData[index][0] = (row[0]);
        });

        pdf.setFont('fontInter', 'bold');
        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0);

        autoTable(pdf, {
            head: bankTableHeaders,
            body: bankTableData,
            startY: currentY,
            styles: {
                font: 'fontInter',
                fontSize: 8,
                valign: 'middle',
                fillColor: '#F5F4F9',
            },
            headStyles: {
                fillColor: [233, 232, 238],
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                valign: 'middle',
            },
            columnStyles: {
                0: { minCellWidth: 80 },
                1: { minCellWidth: 80, fontStyle: 'bold' },
            },
            margin: { left: 12, right: 12 },
        });
        // Tabloyu ekledikten sonra currentY değerini güncelleyin
        currentY = (pdf as any).lastAutoTable.finalY + 10;

        // 'ONAY' Bölümü
        pdf.setFontSize(11);
        pdf.setFont('fontInter', 'bold');
        pdf.setTextColor(255, 255, 255);
        pdf.setFillColor("#333E48");

        // ONAY Metni ve Satır Bölme
        const confirmText: string = '8. ONAY';
        const confirmLines: string[] = pdf.splitTextToSize(confirmText, (maxLineWidth - 4));

        // Sayfa sonu kontrolü
        if (currentY > pageHeight - 30) {
            pdf.addPage();
            addHeader(pdf, proposalData, resolvedLogoBase64);
            currentY = 40;
        }

        // Yuvarlatılmış dikdörtgen çizimi
        pdf.roundedRect(
            marginLeft,                       // x
            currentY,                         // y
            maxLineWidth,                     // width
            12, // height
            2,                     // rx (yatay köşe yarıçapı)
            2,                     // ry (dikey köşe yarıçapı)
            'F'                               // style (Fill)
        );
        // Metni ekleyin (doğru parametre sırası)
        pdf.text(confirmLines, marginLeft + 5, currentY + 7);


        // Y pozisyonunu güncelleyin
        currentY += 10 + 8;

        // Tablo konfigürasyonu
        const startY = currentY;

        // Tablo başlıklarını tanımlayın
        const tableHead = [
            [
                {
                    content: 'MÜŞTERİ KURULUŞ Adına',
                    colSpan: 2,
                    styles: {
                        halign: 'left',
                        fillColor: [233, 232, 238],
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'KONTROLX Adına',
                    colSpan: 2,
                    styles: {
                        halign: 'left',
                        fillColor: [233, 232, 238],
                        fontStyle: 'bold',
                    },
                },
            ],
        ];

        // Tablo gövdesini tanımlayın
        const tableBody = [
            // Adi Soyadi satırı
            [
                { content: 'Adı Soyadı', styles: { halign: 'left' } },
                { content: '', styles: { halign: 'left' } },
                { content: 'Adı Soyadı', styles: { halign: 'left' } },
                { content: 'Ender Aydın', styles: { halign: 'left' } },
            ],
            // Gorevi satırı
            [
                { content: 'Görevi', styles: { halign: 'left' } },
                { content: '', styles: { halign: 'left' } },
                { content: 'Görevi', styles: { halign: 'left' } },
                { content: 'Şirket Müdürü', styles: { halign: 'left' } },
            ],
            // Tarih satırı
            [
                { content: 'Tarih', styles: { halign: 'left' } },
                { content: '', styles: { halign: 'left' } },
                { content: 'Tarih', styles: { halign: 'left' } },
                { content: createdAt, styles: { halign: 'left' } },
            ],
            // Imza / Kase satırı
            [
                { content: 'İmza / Kaşe', styles: { halign: 'left' } },
                { content: '', styles: { halign: 'left' } },
                { content: 'İmza / Kaşe', styles: { halign: 'left' } },
                {
                    content: 'Bu belge, KONTROLX İş Ortağım Platformu kullanılarak hazırlanmış olup, KONTROLX tarafından onaylıdır.',
                    styles: { halign: 'left' },
                },
            ],
        ];

        // TypeScript tip hatalarını önlemek için 'as any' kullanıyoruz
        autoTable(pdf, {
            startY: startY,
            head: tableHead as any[],
            body: tableBody as any[],
            styles: {
                font: 'fontInter',
                fontSize: 8,
                cellPadding: 3,
                fillColor: '#F5F4F9',
                overflow: 'linebreak', // Metinler hücre içinde satır kaydırır
                halign: 'left',
                valign: 'middle',
                lineColor: [255, 255, 255], // Hücre kenarlık rengi beyaz
            },
            headStyles: {
                fillColor: [233, 232, 238], // Başlık arka plan rengi
                textColor: [0, 0, 0], // Başlık metin rengi siyah
                fontStyle: 'bold',
                lineColor: [255, 255, 255],
            },
            margin: { left: marginLeft, right: marginRight },
            tableLineColor: [255, 255, 255],
            tableLineWidth: 0.1,
            columnStyles: {
                0: { cellWidth: 30 },
                1: { cellWidth: 63 },
                2: { cellWidth: 30 },
                3: { cellWidth: 63 },
            },
        });
        const proposalDate = new Date(proposalData.createdAt);
        const formattedDate =
            proposalDate.getFullYear() +
            '-' +
            String(proposalDate.getMonth() + 1).padStart(2, '0') +
            '-' +
            String(proposalDate.getDate()).padStart(2, '0') +
            '-' +
            String(proposalDate.getHours()).padStart(2, '0') +
            '-' +
            String(proposalDate.getMinutes()).padStart(2, '0') +
            '-' +
            String(proposalDate.getSeconds()).padStart(2, '0');

        let proposalNumber = "Teklif_" + proposalData.proposalNumber + "#" + proposalData?.updatedAccountId + "#";

        pdf.setProperties({
            title: `${proposalNumber ?? 'Teklif'}`
        });

        currentY = (pdf as any).lastAutoTable.finalY;

        addFootersToPDF(pdf, proposalData, proposalVersionSetting);

        // Generate PDF Blob
        const pdfBlob = pdf.output('blob');
        console.log('pdfBlob:', pdfBlob);
        const pdfBlobUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfBlobUrl);
        setBlob(pdfBlob);
        pdfInstanceRef.current = pdfBlob;
    };

    // 1) Blob'dan File oluşturma
    const handlePdfUpload = async () => {
        if (count.current > 1) {
            return;
        }

        try {
            const { groupedByOffering, data, formattedDate, serviceFeePrice, proposalVersionSetting } = await getInfos();
            if (!data?.id) {
                throw new Error('Teklif bilgisi alınamadı.');
            }

            await generatePdf(groupedByOffering, data, formattedDate, serviceFeePrice, proposalVersionSetting);
            const pdfBlob = pdfInstanceRef.current;

            if (!pdfBlob) {
                throw new Error("PDF blob is null");
            }

            const file = new File([pdfBlob], `proposal-${data.proposalNumber || data.id}.pdf`, {
                type: "application/pdf",
            });

            const archiveResponse = await ProposalService.uploadPdfArchive(data.id, file);

            if (isSendMail) {
                await ProposalService.update(data.id, { statusId: 3, invoiceEmailSendAt: scheduledAt });
            }

            if (!silent) {
                if (isCreate) {
                    openNotification('success', 'Başarılı', 'Teklif başarıyla oluşturuldu.');
                } else {
                    if (isSendMail) {
                        openNotification('success', 'Başarılı', 'Teklif Gönderildi.');
                        setTimeout(() => {
                            window.location.reload();
                        }, 1500);
                    } else {
                        openNotification('success', 'Başarılı', 'Teklif başarıyla güncellendi.');
                    }
                }
            }
            onSuccess?.(archiveResponse?.data);
            if (shouldNavigate) {
                navigate('/proposals', { replace: true });
            }
        } catch (error) {
            console.error("PDF upload hatası:", error);
            if (!silent) {
                openNotification('error', 'Hata', 'Teklif PDF’i oluşturulamadı.');
            }
            onError?.(error);
        }
    };

    useEffect(() => {
        if (!status) {
            count.current = count.current + 1;
            setStatus(true)
            handlePdfUpload()
        }

    }, [])

    return null;
};

export default PdfUpload;
